<template>
  <div>
    <!-- 头部 -->
    <div id="web-header" ref="headerSection">
      <b-navbar toggleable="lg" class="custim-navbar">
        <div class="container-fluid">
          <!-- logo -->
          <b-navbar-brand class="web-header-logo" @click="navigateToHome">
            <img class="logo" src="../../assets/web/img/logo.png" alt="login" @click="navigateToHome" />
            <!-- 移动端的logo -->
            <img class="logo-p" src="../../assets/web/img/p-logo.png" alt="login" @click="navigateToHome" />
          </b-navbar-brand>
          <!-- 按钮 -->
          <b-navbar-toggle target="web-header-nav-collapse">
          </b-navbar-toggle>
          <!-- 导航栏列表 -->
          <b-collapse is-nav id="web-header-nav-collapse" ref="collapse" :class="{'my-navbar':!isNoNewsPage}">
            <b-navbar-nav class="mx-auto">
              <!-- 自定义样式 -->
              <div v-for="(item,index) in navList" class="text-link" :class="{'active':currentIndex == index}"
                :key="index" @click="changeIndexm(item)" v-scroll-to="{ el: '#' + item.linkid, offset: 0 }">
                <span>{{item.title}}</span>
              </div>
              <!-- 联系电话 -->
            </b-navbar-nav>
            <div class="hot-line  d-none d-md-block">
              <div class="text-links">
                <div><img class=" tel" src="../../assets/web/img/tel.png" alt=""></div>
                <div><span class="text">{{companyInfo.inquiryPhone}}</span></div>
              </div>
            </div>
          </b-collapse>
        </div>
      </b-navbar>
    </div>
    <div v-if="isNoNewsPage">
      <!-- 轮播图 -->
      <div id="content-carousel" class="content-carousel">
        <b-carousel id="carousel-1" v-model="slide" :interval="3000" indicators background="#ffffff" img-width="1020"
          img-height="711" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd">
          <b-carousel-slide v-for="(item,index) in slideList" :key="index">
            <template #img>
              <img v-if="deviceType == 'desktop'" class="d-block img-fluid w-100 d-none d-md-block" width="1024"
                height="811" :src="item.imgUrl" alt="图片加载中">
              <img v-if="deviceType == 'mobile'" class="d-block img-fluid w-100 d-md-none" width="1024" height="811"
                :src="item.imgUrlphone" alt="图片加载中">
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
      <!-- 内容显示 -->
      <div id="content-introduce" class="d-none d-md-block content-introduce">
        <div class="content-introduce-content">
          <div class="img-content">
            <img :src="signListimg" alt="" class="full-width">
          </div>
        </div>
      </div>
      <!-- 关于光晨 -->
      <section class="wow animated  fadeInUp" data-wow-duration="1.5s">
        <div id="content-about">
          <div class="connect-life">
            <div class="wrapper">
              <div class="container-fluid" style="overflow: hidden;">
                <div class="row">
                  <div class="col-12 col-md-6 content-left">
                    <div class="c-title">关于光晨</div>
                    <img src="../../assets/web/img/about-line.png" alt="" class="c-line">
                    <div class="c-sub-title wow animated  fadeInUp" data-wow-duration="1.5s">
                      {{companyInfo.subtitle}}
                    </div>
                    <div class="c-content wow animated  fadeInUp" data-wow-duration="1.5s">
                      <div class="c-content-text" v-html="splitsubdescription(companyInfo.description)">
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 text-center d-none d-md-block box-right wow animated  fadeInUp"
                    data-wow-duration="1.5s">
                    <img class="c-img" :src="companyInfo.rightSideImageUrl" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 发展历程-->
      <section>
        <div id="content-development" class="content-development">
          <div class="wrapper" style="overflow: hidden;">
            <div class="d-md-none sm-title">
              发展历程</div>
            <img src="../../assets/web/img/about-line.png" alt="" class="d-md-none  sm-line wow animated  fadeInUp"
              data-wow-duration="1.5s">
            <div class="d-md-none sm_swiper wow animated  fadeInUp" data-wow-duration="1.5s">
              <swiper class="swiper" :options="swiperOption">
                <swiper-slide v-for="(item,index) in developmentList" :key="index">
                  <div class="swiper_item_one">
                    <div class="img"><img :src="item.eventImageUrl" alt=""></div>
                    <div class="year">{{item.title}}</div>
                    <div class="explain">{{item.description}}</div>
                  </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
            <div class="d-none d-md-block lg_swiper">
              <div class="s-title  wow animated  fadeInUp" data-wow-duration="1.5s">
                <div class="s-title-textimg">
                  <div class="text">发展历程</div>
                  <div class="imgs">
                    <img src="../../assets/web/img/about-line.png" alt="">
                  </div>
                </div>
              </div>

              <swiper class="swiper wow animated  fadeInUp" data-wow-duration="1.5s" :options="swiperOption1"
                ref="mySwiper" @slideChange="handleSlideChange">
                <swiper-slide v-for="(item,index) in developmentList" :key="index">
                  <!-- 显示的内容 -->
                  <div class="container-fluid swiper_item_one_bg">
                    <div class="item_one_left">
                      <div class="s-title">{{item.year}}</div>
                      <p class="s-content-text">
                        {{item.description}}
                      </p>
                    </div>
                    <div class="item_one_right">
                      <div class="s-line">
                        <img src="../../assets/web/img/devlop-line.png" alt="">
                      </div>
                      <div>
                        <img :src="item.eventImageUrl" alt="" class="s-img">
                      </div>
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
              <div class="wow animated  fadeInUp" data-wow-duration="1.5s">
                <div class="nav-pagination">
                  <div @click="linkpre"><img src="../../assets/web/img/new-left.png" alt=""></div>
                  <div @click="linkto(index)" class="icon-text" v-for="(item,index) in developmentList" :key="index">
                    <div class="link-left"><img src="../../assets/web/img/new-yuan.png" alt=""></div>
                    <div class="icon-texts">
                      <div v-if="index == currentIndexPag"><img src="../../assets/web/img/year-select.png" alt=""
                          class="img-bgs"></div>
                      <div v-else><img src="../../assets/web/img/yuan.png" alt="" class="img-bg"></div>
                      <!-- <div><img src="../../assets/web/img/year-select.png" alt="" class="img-bgs"></div> -->
                      <div v-if="index == currentIndexPag" class="text-scotts-checked">{{item.title}}</div>
                      <div v-else class="text-scotts">{{item.title}}</div>
                      <!-- <div class="text-scotts-checked">{{item.year}}</div> -->
                    </div>
                  </div>
                  <div class="link-right" @click="linknext">
                    <img src="../../assets/web/img/new-yuan.png" alt="">
                    <img src="../../assets/web/img/new-right.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 核心业务 -->
      <section>
        <div id="content-business" class="content-business">
          <div class="wrapper" style="overflow: hidden;">
            <div class="container-fluid d-none d-md-block" style="overflow: hidden;">
              <div class="b-title wow animated  fadeInUp" data-wow-duration="1.5s">
                <div class="b-title-textimg">
                  <div class="text">核心业务</div>
                  <div class="imgs">
                    <img src="../../assets/web/img/about-line.png" alt="">
                  </div>
                </div>
              </div>
              <div class="row  wow animated  fadeInUp" data-wow-duration="1.5s">
                <div :class="[
                'wow',
                'col-md-3',
                'col-xl-3',
                'item',
                'animated',
                'fadeInUp',
              ]" :style="{ backgroundImage: 'url(' + (item.active ? item.activeBackgroundImage : item.backgroundImage) + ')' }"
                  v-for="(item,index) in topBList" :key="item.id" @mouseover="setActiveBackground(item.id)"
                  @mouseleave="resetActiveBackground(item.id)">
                  <div class="num" :class="{ 'actives': item.active }">
                    <div>{{item.num}}</div>
                  </div>
                  <div class="content">
                    <div class="name_en" :class="{ 'actives': item.active }">{{item.en}}</div>
                    <div class="name_zn" :class="{ 'actives': item.active }">{{item.zh}}</div>
                  </div>
                  <div class="content-expain" :class="{ 'actives': item.active }">
                    <p>{{item.explain}}</p>
                  </div>
                </div>
              </div>
              <div class="row wow animated  fadeInUp" data-wow-duration="1.5s">
                <div :class="[
                'wow',
              'col-md-3',
              'col-xl-3',
              'item',
              'animated',
              'fadeInUp',
            ]" :style="{ backgroundImage: 'url(' + (item.active ? item.activeBackgroundImage : item.backgroundImage) + ')' }"
                  v-for="(item,index) in bottomBlist" :key="item.id" @mouseover="setActiveBackgrounds(item.id)"
                  @mouseleave="resetActiveBackgrounds(item.id)">
                  <div class="num" :class="{ 'actives': item.active }">
                    <div>{{item.num}}</div>
                  </div>
                  <div class="content">
                    <div class="name_en" :class="{ 'actives': item.active }">{{item.en}}</div>
                    <div class="name_zn" :class="{ 'actives': item.active }">{{item.zh}}</div>
                  </div>
                  <div class="content-expain" :class="{ 'actives': item.active }">
                    <p>{{item.explain}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="container-fluid d-md-none wow animated  fadeInUp" data-wow-duration="1.5s">
              <div class="b-title wow animated fadeInUp" data-wow-duration="1.5s">核心业务</div>
              <img src="../../assets/web/img/about-line.png" alt=""
                class="sm-line wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">
              <div class="content wow animate__animated animate__fadeInUp" data-wow-duration="1.5s">
                <swiper class="swiper" :options="swiperOption3" ref="myswiperB">
                  <swiper-slide>
                    <div class="row">
                      <div class="col-6 item" v-for="item in topBList" :key="item.id"
                        :style="{ backgroundImage: 'url(' + (item.active ? item.activeBackgroundImage : item.backgroundImage) + ')' }">
                        <div class="num">
                          <div>{{item.num}}</div>
                        </div>
                        <div class="content">
                          <div class="name_en">{{item.en}}</div>
                          <div class="name_zn">{{item.zh}}</div>
                        </div>
                        <div class="content-expain">
                          <p>{{item.explain}}</p>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                  <swiper-slide>
                    <div class="row">
                      <div class="col-6 item" v-for="item in bottomBlist" :key="item.id"
                        :style="{ backgroundImage: 'url(' + (item.active ? item.activeBackgroundImage : item.backgroundImage) + ')' }">
                        <div class="num">
                          <div>{{item.num}}</div>
                        </div>
                        <div class="content">
                          <div class="name_en">{{item.en}}</div>
                          <div class="name_zn">{{item.zh}}</div>
                        </div>
                        <div class="content-expain">
                          <p>{{item.explain}}</p>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 服务案例 -->
      <section>
        <div id="content-servicecases" class="content-servicecases">
          <div class="wrapper  wow animated  fadeInUp" data-wow-duration="1.5s" style="overflow: hidden;">
            <!-- 大屏显示 -->
            <div class="s-container-fluid d-none d-md-block wow" style="overflow: hidden;">
              <div class="se-title wow animated  fadeInUp" data-wow-duration="1.5s">
                <div class="se-title-textimg">
                  <div class="text">服务案例</div>
                  <div class="imgs">
                    <img src="../../assets/web/img/ser-line.png" alt="" class="se-line">
                  </div>
                </div>
              </div>
              <div class="se-content wow">
                <div class="wow">
                  <div class="row wow animated fadeInUp" v-for="(item,index) in serviceBgList" :key="index"
                    data-wow-duration="1.5s">
                    <div v-for="(itemS,indexS) in item" :key="indexS" :class="[
                    'wow',
                    'animated',
                    'fadeInUp',
                ]">
                      <div class="s-item">
                        <div class="top-img">
                          <div class="img-bg"><img :src="itemS.partnerLogoUrl" alt=""></div>
                        </div>
                        <div class="text">{{itemS.businessPromotion}}</div>
                        <div class="description">{{itemS.partnerDescription}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 小屏显示 -->
            <div class="s-container-fluid d-md-none wow animated fadeInUp" data-wow-duration="1.5s">
              <div class="s-content wow animate__animated animate__fadeInUp " data-wow-duration="1.5s">
                <div class="se-title-textimg">
                  <div class="text">服务案例</div>
                  <div class="imgs">
                    <img src="../../assets/web/img/ser-line.png" alt="" class="se-line">
                  </div>
                </div>
                <swiper class="swiper" :options="swiperOption4" ref="myswiperC">
                  <swiper-slide v-for="(item,index) in serviceBgList" :key="index">
                    <div class="row">
                      <div v-for="(itemS,indexS) in item" :key="indexS">
                        <div class="s-item">
                          <div class="top-img">
                            <div><img :src="itemS.partnerLogoUrl" alt=""></div>
                          </div>
                          <div class="text">{{itemS.businessPromotion}}</div>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 新闻公告 -->
      <section>
        <div id="content-newsannouncement">
          <div class="wrapper">
            <div class="n-container-fluid" style="overflow: hidden;">
              <div class="n-title wow animated fadeInUp" data-wow-duration="1.5s">
                <div class="n-title-textimg">
                  <div class="text">新闻公告</div>
                  <div class="imgs">
                    <img src="../../assets/web/img/about-line.png" alt="">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-6 col-xl-6 wow animated fadeInUp" data-wow-duration="1.5s">
                  <div class="album" @click="linkInfo(newsListFirst)">
                    <div class="a_imgs">
                      <img :src="newsListFirst.headerImageUrl" alt="">
                    </div>
                    <div class="info">
                      <div class="info-desc nowrap_ellipsis">
                        {{newsListFirst.title}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-xl-6  wow animated fadeInUp" data-wow-duration="1.5s">
                  <div class="news-right">
                    <ul class="news-list">
                      <li class="item" v-for="(item,index) in newsList" :key="item.id" @click="linkInfo(item)">
                        <span class="dot"></span>
                        <div class="desc nowrap_ellipsis">
                          {{item.title}}
                        </div>
                        <span class="date">{{item.handleDate}}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="img col-12 col-md-12 col-xl-12 d-flex justify-content-center  wow animated fadeInUp"
                  data-wow-duration="1.5s">
                  <div class="btn" @click="linkToNewsList">
                    <img src="../../assets/web/img/btn-bg.png" alt="" class="bg">
                    <img src="../../assets/web/img/learn-more@2x.png" alt="" class="test">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 联系我们 -->
      <section ref="contentContactus">
        <div id="content-contactus" class="content-contactus">
          <div class="wrapper">
            <div class="u-container-fluid wow animated slideInLeft" data-wow-duration="1.5s">
              <div class="u-title">
                <div class="u-title-textimg">
                  <div class="text">联系我们</div>
                  <div class="imgs">
                    <img src="../../assets/web/img/about-line.png" alt="" class="u-line">
                  </div>
                </div>
              </div>
              <div class="row">
                <div v-for="(item,index) in contactUsList" class="col-6 col-md-3 col-xl-3" :key="index">
                  <div class="u-item">
                    <div class="u-top">
                      <div><img :src="item.iconImg" alt="" class="colorize"></div>
                      <div class="text-center">{{item.title}}</div>
                    </div>
                    <p class="u-bottom" v-if="index===0" v-html="splitAddress(item.detailedInfo)">
                    </p>
                    <div class="u-bottoms" v-else>
                      {{item.detailedInfo}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-12 col-xl-12  d-flex justify-content-center">
                  <div class="image-container">
                    <img v-if="deviceType == 'desktop'" :src=companyImgUrl alt="" class="rea-address">
                    <img v-else :src=companyImgUrlmobil alt="" class="rea-address">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <newsContent></newsContent>
    </div>
    <!-- 底部 -->
    <div id="foot" class="foot">
      <div class="wrapper">
        <!-- 大屏显示 -->
        <div class="container-fluid d-none d-md-block">
          <div class="row">
            <div class="col-12 col-md-4 col-xl-4">
              <div class="left">
                <div class="top-text">
                  <div class="top-text-title">友情链接</div>
                  <div class="top-text-item">
                    <div class="item-one" v-for="(item,index) in friendlyLinks" :key="index">
                      <a :href=item.Url target="_blank" rel="noopener noreferrer">{{item.Text}}</a>
                    </div>
                    <!-- <div><a :href=websiteConfig.bomUrl target="_blank"
                        rel="noopener noreferrer">{{websiteConfig.bomText}}</a></div> -->
                  </div>
                </div>
                <div class="logo"><img src="../../assets/web/img/foot-logo.png" alt=""></div>
              </div>
            </div>
            <div class="col-12 col-md-4 col-xl-4">
              <div class="center">
                <div class="text">官方微信</div>
                <div class="wechat"><img :src=websiteConfig.weChat alt=""></div>
              </div>
            </div>
            <div class="col-12 col-md-4 col-xl-4">
              <div class="right">
                <div class="top-text">全国服务热线</div>
                <div class="phone">{{companyInfo.inquiryPhone}}</div>
                <div class="email">邮箱:<span>{{companyInfo.contactEmail}}</span></div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-12 col-xl-12">
              <div class="bottom">
                <div class="content">
                  <div class="top">Copyright©2015-2020广州光晨信息科技有限公司版权所有</div>
                  <div>
                    <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">粤ICP备15080429号</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 小屏显示 -->
        <div class="f-container-fluid d-md-none">
          <div class="foot-mg-content">
            <div class="top">
              <div class="top-content">
                <div class="top-text">全国服务热线</div>
                <div class="imgs">{{companyInfo.inquiryPhone}}</div>
                <div class="email">邮箱:<span>{{companyInfo.contactEmail}}</span></div>
              </div>
            </div>
            <div class="center">
              <div class="wechat"><img :src=websiteConfig.weChat alt=""></div>
            </div>
            <div class="bottom">
              <div class="content">
                <div class="top">Copyright©2015-2020广州光晨信息科技有限公司版权所有<span> <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">粤ICP备15080429号</a></span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios';
  import dayjs from 'dayjs'
  // 获取设备类型（简单示例，实际上最好使用CSS媒体查询辅助判断）
  function getDeviceType() {
    const width = window.innerWidth || document.documentElement.clientWidth;
    if (width > 768) {
      return 'desktop';
    } else {
      return 'mobile';
    }
  }
  // 处理数组的分隔方式
  function chunkArray(array, size) {
    const chunked_arr = [];
    for (let i = 0; i < array.length; i += size) {
      chunked_arr.push(array.slice(i, i + size));
    }
    return chunked_arr;
  }


  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import newsContent from "./newsContent.vue";
  export default {
    name: "App",
    components: {
      swiper,
      swiperSlide,
      newsContent
    },
    data() {
      return {
        deviceType: "",//判断页面是手机端还是桌面端
        navList: [
          {
            id: "1",
            title: '首页',
            linkid: "web-header",
            page: "page1"
          },
          {
            id: "2",
            title: '关于光晨',
            linkid: "content-about",
            page: "page2"
          },
          {
            id: "3",
            title: '发展历程',
            linkid: "content-development",
            page: "page3"
          },
          {
            id: "4",
            title: '核心业务',
            linkid: "content-business",
            page: "page4"
          },
          {
            id: "5",
            title: '服务案例',
            linkid: "content-servicecases",
            page: "page5"
          },
          {
            id: "6",
            title: '新闻公告',
            linkid: "my",
            page: "page6"
          },
          {
            id: "7",
            title: '联系我们',
            linkid: "content-contactus",
            page: "page7"
          },
        ],
        currentIndex: "",
        slide: 0,
        sliding: null,
        slideList: [
          {
            id: 1,
            title: "品牌营销",
            content: "专注事件营销，塑造品牌形象，提升品牌知名度",
            imgUrl: "",
            imgUrlphone: ""
          },
          {
            id: 2,
            title: "视频运营",
            content: "用创意为品牌带来持续性的声量,用内容为品牌带来有效产品转化",
            imgUrl: "",
            imgUrlphone: ""
          },
          {
            id: 3,
            title: "达人MCN",
            content: "为品牌创造新的生意增长",
            imgUrl: "",
            imgUrlphone: ""
          },
        ],
        signListimg: "",
        signList: [
          {
            id: 1,
            content: '内容营销之路',
            num: '8',
            unit: '年',
            imgURl: require('@/assets/web/img/trophy.png')
          },
          {
            id: 2,
            content: '平均满意率',
            num: '90',
            unit: '%',
            imgURl: require('@/assets/web/img/like.png')
          },
          {
            id: 3,
            content: '服务品牌',
            num: '200',
            unit: '+',
            imgURl: require('@/assets/web/img/collection.png')
          },
          {
            id: 4,
            content: '签约客户',
            num: '2000',
            unit: '+',
            imgURl: require('@//assets/web/img/sign.png')
          },
          {
            id: 5,
            content: '营收突破',
            num: '10',
            unit: '亿',
            imgURl: require('@//assets/web/img/revenue.png')
          }
        ],
        // 发展历程
        swiperOption: {
          slidesPerView: 2,
          spaceBetween: 30,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            autoplay: {
              delay: 7000, // 设置轮播每隔 5 秒切换到下一项，单位为毫秒
            },
          }
        },
        swiperOption1: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          autoplay: {
            delay: 7000, // 设置轮播每隔 5 秒切换到下一项，单位为毫秒
          },
        },
        developmentList: [
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2023",
            contentText: "凭借自研舆情服务系统2.0荣获2023年国家高新技术认证，同时全年总流水金额首次突破10亿元！"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2022",
            contentText: "获得抖音平台云图服务认证、抖音电商千川2星服务商认证"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2021",
            contentText: "荣获金投赏商业创意奖、ARPC共擎奖等荣誉；光晨党支部成立，同时成为新华社半月谈党建学习站点"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2020",
            contentText: "创建运营新格局，形成社媒公关、新媒体运营、视频制作、效果投放、达人投放五大业务板块"
          }, {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2019",
            contentText: "进入视频制作领域，成立视频团队，赋能抖音/快手等短视频平台的效果广告业务以及品牌/产品视频素材拍摄制作"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2018",
            contentText: "公司成为360、巨量引擎等巨头全国核心代理，全面拓展业务量"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2017",
            contentText: "获得多项技术专利及软件著作权，被广东省科技厅认定为“国家高新技术企业”"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2016",
            contentText: "成为百度KA全国核心代理"
          },
          {
            imgUrl: require('@/assets/web/img/devpo-phone.png'),
            year: "2015",
            contentText: "光晨科技正式注册成立，帮助品牌在互联网进行内容营销"
          },
        ],
        currentIndexPag: 0,//选中的
        swiperOption3: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          autoplay: {
            delay: 7000, // 设置轮播每隔 5 秒切换到下一项，单位为毫秒
          },
        },
        // 核心业务相关的便变量
        topBList: [
          { displayOrder: 1, id: 0, backgroundImage: require('@/assets/web/img/new_unactive_01.jpg'), activeBackgroundImage: require('@/assets/web/img/active_01.jpg'), active: false, num: '01', en: "Brand Operation", zh: "品牌设计", explain: "深厚积淀的视觉综合创作及应用能力，注重细节、设计质感，擅捕捉品牌调性" },
          { displayOrder: 2, id: 1, backgroundImage: require('@/assets/web/img/new_unactive_02.jpg'), activeBackgroundImage: require('@/assets/web/img/active_02.jpg'), active: false, num: '02', en: "New Media", zh: "品牌运营", explain: "实现全媒体优化，提升品牌美誉度" },
          { displayOrder: 3, id: 2, backgroundImage: require('@/assets/web/img/new_unactive_03.jpg'), activeBackgroundImage: require('@/assets/web/img/active_03.jpg'), active: false, num: '03', en: "Branding", zh: "视频创意", explain: "用创意为品牌带来持续性的声量 用内容为品牌带来有效产品转化" },
          { displayOrder: 4, id: 3, backgroundImage: require('@/assets/web/img/new_unactive_04.jpg'), activeBackgroundImage: require('@/assets/web/img/active_04.jpg'), active: false, num: '04', en: "Video Creativity", zh: "新媒体", explain: "为品牌提供有价值、有深度的优质内容，提高品牌全域传播声量" },
        ],
        bottomBlist: [
          { displayOrder: 5, id: 0, backgroundImage: require('@/assets/web/img/new_unactive_05.jpg'), activeBackgroundImage: require('@/assets/web/img/active_05.jpg'), active: false, num: '05', en: "Advertisement", zh: "媒体代理", explain: "夯实基础，开拓创新，为客户提供最优质的的代理服务" },
          { displayOrder: 6, id: 1, backgroundImage: require('@/assets/web/img/new_unactive_06.jpg'), activeBackgroundImage: require('@/assets/web/img/active_06.jpg'), active: false, num: '06', en: "Brand Live Streaming", zh: "流量运营", explain: "运营品牌的生意增长" },
          { displayOrder: 7, id: 2, backgroundImage: require('@/assets/web/img/new_unactive_07.jpg'), activeBackgroundImage: require('@/assets/web/img/active_07.jpg'), active: false, num: '07', en: "Tiktok Team", zh: "品牌种草", explain: "为品牌的口碑做高效增量" },
          { displayOrder: 8, id: 3, backgroundImage: require('@/assets/web/img/new_unactive_08.jpg'), activeBackgroundImage: require('@/assets/web/img/active_08.jpg'), active: false, num: '08', en: "Xiaohongshu Team", zh: "电商直播", explain: "直播部—专业打造精彩直播，助力品牌高效增长" },
        ],
        // 服务案例
        swiperOption4: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          autoplay: {
            delay: 7000, // 设置轮播每隔 5 秒切换到下一项，单位为毫秒
          },
        },
        // 服务案例数据(大屏)
        serviceBgList: [],
        serviceLgList: [],
        companyInfo: {
          inquiryPhone: "020-3757 4075"
        },
        // 联系我们模块
        contactUsList: [
          {
            id: 1,
            iconImg: require('@/assets/web/img/u-newaddress.jpg'),
            title: "地址",
            detailedInfo: "广东省广州市越秀区 广州大道中富力东山新天地中心2801"
          },
          {
            id: 2,
            iconImg: require('@/assets/web/img/u-newphone.jpg'),
            title: "电话",
            detailedInfo: "13808882966"
          },
          {
            id: 3,
            iconImg: require('@/assets/web/img/u-newDocking.jpg'),
            title: "商务对接",
            detailedInfo: "12345678910"
          },
          {
            id: 4,
            iconImg: require('@/assets/web/img/u-newemail.jpg'),
            title: "邮箱",
            detailedInfo: "hr@guangchen.cc"
          },
        ],
        companyImgUrl: require('@/assets/web/img/u-realnewaddress.png'),
        companyImgUrlmobil: require('@/assets/web/img/u-realnewaddress.png'),
        // 新闻数据
        newsList: [],
        newsListFirst: {},
        // 底部数据回显
        websiteConfig: {
          topText: "光晨科技",
          topUrl: "https://www.baidu.com/",
          bomText: "米麦传媒",
          bomUrl: "https://www.baidu.com/",
          weChat: require('@/assets/web/img/foot-wechat.png')
        },
        friendlyLinks: [
        ],
        // 动画效果设置
        // isContentAbout: false,
        // isContentDevelopment: false,
        // isContentBusiness: false,
        // iscontentServicecases: false,
        // isContentNewsannouncement: false,
        // iscontentContactus: false,
        // // 检测是否是首页
        // isNoNewsPage: localStorage.getItem("isNoNewsPage") ? localStorage.getItem("isNoNewsPage") : true,
        isNoNewsPage: config.isNoNewsPage
      };
    },
    metaInfo() {
      return {
        title: "光晨科技,广州光晨科技—广州光晨信息科技有限公司",
        meta: [
          { name: "keywords", content: "光晨科技,广州光晨科技,广州光晨信息科技有限公司" },
          { name: "description", content: "光晨科技成立于2015年，凭借大数据输出的战略洞察、创造力、行动力等生产实效的核心竞争力，为客户提供全域数字内容营销。" },
        ],
      };
    },
    created() {
      if (localStorage.getItem('currentIndex')) {
        this.currentIndex = JSON.parse(localStorage.getItem('currentIndex'))
      }

    },

    destroyed() {
      // 一定要在组件销毁前移除事件监听，防止内存泄露
      window.removeEventListener('popstate', this.handleBackButton);
      window.removeEventListener('beforeunload', this.handleBackButton);
    },

    async mounted() {
      this.$nextTick(() => {
        this.$wow.init();
      });
      window.addEventListener('popstate', this.handleBackButton);
      window.addEventListener('beforeunload', this.handleBackButtons);

      this.deviceType = getDeviceType();
      // 添加窗口大小改变时的事件监听，以便在设备方向改变或窗口大小调整时更新设备类型
      window.addEventListener('resize', () => {
        this.deviceType = getDeviceType();
      });
      // 切换手机端需要默认加载动画
      // if (this.deviceType == 'mobile') {
      //   this.isContentAbout = true
      // }
      try {
        // 使用axios发起GET请求 
        const response = await axios.get('https://www.glotech.com.cn/api/v1/home/config/get');
        // 新闻公告数据
        const data = {
          page: 0,
          count: 8,
          publishStatus: 1
        }
        const news = await axios.post('https://www.glotech.com.cn/api/v1/news/page', data, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        // 处理响应数据
        let items = response.data;
        let getnews = news.data.records
        this.handleNewData(getnews)
        // 数据处理
        this.handleData(items)
      } catch (error) {
        console.error("An error occurred:", error);
      };
      // 增加监听事件
      // window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      navigateToHome() {
        this.isNoNewsPage = true
        this.currentIndex = 0
        localStorage.setItem("isNoNewsPage", this.isNoNewsPage)
        localStorage.setItem("currentIndex", this.currentIndex)
        this.$router.push({
          name: "web",
        }).catch(error => {
          if (error.name === 'NavigationDuplicated') {
            console.warn('尝试导航到当前页面，已忽略重复操作');
          } else {
            throw error;
          }
        });
      },
      splitAddress(value) {
        if (value) {
          // 找到"越秀区"在地址字符串中的位置
          const index = value.indexOf('广州大道');
          // 如果找到了"越秀区"，返回"越秀区"之前的部分和"越秀区"之后的部分以换行分隔
          return index !== -1 ? value.slice(0, index) + '<br>' + value.slice(index) : value;
        }
      },
      splitsubdescription(value) {
        if (value) {
          const index = value.indexOf('光晨科技持续服务');
          return index !== -1 ? value.slice(0, index) + '<br>' + value.slice(index) : value;
        }
      },
      handleBackButton() {
        if (this.$route.path === '/') {
          this.isNoNewsPage = true
          this.currentIndex = 0
        }
        else {
          this.isNoNewsPage = false
        }

      },
      handleBackButtons() {
        if (this.$route.path === '/') {
          this.isNoNewsPage = true
          this.currentIndex = 0
        }
        else {
          this.isNoNewsPage = false
        }

      },
      // handleScroll() { // 实现当滚动到指定位置，触发动画
      //   // let scrollTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 获取窗口滚动条高度
      //   // this.gdjz('earth', 'earth animated bounceInDown', 50)
      //   let _this = this
      //   let refArray = [
      //     { ref: 'headerSection', show: 'isheaderSection' },
      //     { ref: 'contentAbout', show: 'isContentAbout' },
      //     { ref: 'contentDevelopment', show: 'isContentDevelopment' },
      //     { ref: 'contentBusiness', show: 'isContentBusiness' },
      //     { ref: 'contentServicecases', show: 'iscontentServicecases' },
      //     { ref: 'contentNewsannouncement', show: 'isContentNewsannouncement' },
      //     { ref: 'contentContactus', show: 'iscontentContactus' }
      //   ]
      //   refArray.forEach((r, i) => {
      //     _this.gdjz(r.ref, 100, () => {
      //       _this[r.show] = true
      //     })
      //   })
      // },
      // gdjz(div, offset, callback) {
      //   let dom = this.$refs[div] // 等同于document.querySelector('.earth') true
      //   if (dom) {
      //     var a, b, c, d;
      //     d = dom.offsetTop // 元素距离相对父级的高度，这里父级指的是body
      //     a = eval(d + offset)
      //     b = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop //  获取窗口滚动条高度
      //     c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
      //     // console.log(b, 'b', c, 'c', '----------', a, 'a')
      //     if (b + c > a) {
      //       setTimeout(() => {
      //         callback && callback()
      //       }, 1000)

      //     }
      //   }
      // },
      // 选中标识
      changeIndex(item) {
        // 点击导航项时，将当前索引设置为点击项的索引
        this.currentIndex = item.id - 1
        this.$refs.fullpage.api.moveTo(item.linkid)
      },
      changeIndexm(item) {
        this.currentIndex = item.id - 1
        if (this.deviceType == 'mobile') {
          // 关闭折叠菜单
          this.$refs.collapse.toggle(false); // 这里将参数设置为 false，表示关闭
        }
        if (this.currentIndex == 5) {
          this.isNoNewsPage = false
          localStorage.setItem("isNoNewsPage", this.isNoNewsPage)
          localStorage.setItem("currentIndex", this.currentIndex)
          this.$router.push({
            name: "NewsList",
          }).catch(error => {
            if (error.name === 'NavigationDuplicated') {
              console.warn('尝试导航到当前页面，已忽略重复操作');
            } else {
              throw error;
            }
          });
        } else {
          this.isNoNewsPage = true
          localStorage.setItem("isNoNewsPage", this.isNoNewsPage)
          localStorage.setItem("currentIndex", this.currentIndex)
          this.$router.push({
            name: "web",
          }).catch(error => {
            if (error.name === 'NavigationDuplicated') {
              console.warn('尝试导航到当前页面，已忽略重复操作');
            } else {
              throw error;
            }
          });
        }

      },
      linkToNewsList() {
        this.isNoNewsPage = false
        this.currentIndex = 5
        localStorage.setItem("isNoNewsPage", this.isNoNewsPage)
        localStorage.setItem("currentIndex", this.currentIndex)
        this.$router.push({
          name: "NewsList",
        }).catch(error => {
          if (error.name === 'NavigationDuplicated') {
            console.warn('尝试导航到当前页面，已忽略重复操作');
          } else {
            throw error;
          }
        });
      },
      onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      },
      linkto(index) {
        this.currentIndexPag = index
        this.$refs.mySwiper.swiper.slideTo(index);
        this.$refs.mySwiper.swiper.autoplay.start();
      },
      linkpre() {
        if (this.currentIndexPag === 0) {
          this.$refs.mySwiper.swiper.slideTo(9);
        } else {
          this.$refs.mySwiper.swiper.slideTo(this.currentIndexPag - 1);
        }
        this.$refs.mySwiper.swiper.autoplay.start();
      },
      linknext() {
        if (this.currentIndexPag + 1 == 9) {
          this.$refs.mySwiper.swiper.slideTo(0);
        } else {
          this.$refs.mySwiper.swiper.slideTo(this.currentIndexPag + 1);
        }
        this.$refs.mySwiper.swiper.autoplay.start();
      },
      handleSlideChange() {
        // 获取 Swiper 实例并检查当前活动的轮播项索引
        const activeIndex = this.$refs.mySwiper.swiper.activeIndex;
        this.currentIndexPag = activeIndex
      },
      // 核心业务的方法
      setActiveBackground(index) {
        this.topBList[index].active = true;
      },
      resetActiveBackground(index) {
        this.topBList[index].active = false;
      },
      setActiveBackgrounds(index) {
        this.bottomBlist[index].active = true;
      },
      resetActiveBackgrounds(index) {
        this.bottomBlist[index].active = false;
      },
      // 各个模块的数据处理
      handleData(Alldata) {
        // 处理轮播图数据
        let slideAllpicData = Alldata.indexPicList.filter(item => item.type !== 3);
        for (const itemT of slideAllpicData) {
          // 1.PC端 2.移动端
          if (itemT.type === 1) {
            for (const item of this.slideList) {
              if (item.id == itemT.displayOrder) {
                item.imgUrl = itemT.pic
              }
            }
          } else if (itemT.type === 2) {
            for (const item of this.slideList) {
              if (item.id == itemT.displayOrder) {
                item.imgUrlphone = itemT.pic
              }
            }
          }
        }
        // 首页下的log type=3
        let slideAlllogoData = Alldata.indexPicList.filter(item => item.type === 3);
        for (const item of slideAlllogoData) {
          for (const itemT of this.signList) {
            if (itemT.id === item.displayOrder) {
              itemT.content = item.title
              itemT.imgURl = item.pic
              // 数字未处理
              itemT.num = item.content
              itemT.unit = item.contentv2
            }

          }
        }
        let slideAlllogoDataImg = Alldata.indexPicList.filter(item => item.type === 4);
        this.signListimg = slideAlllogoDataImg[0].pic;

        // 处理发展历程的数据
        Alldata.milestonesList.sort((a, b) => b.year - a.year)
        this.developmentList = Alldata.milestonesList
        // 核心业务数据处理
        let coreBusinessesList = Alldata.coreBusinessesList
        for (const item of coreBusinessesList) {
          for (const itemT of this.topBList) {
            if (item.displayOrder === itemT.displayOrder) {
              itemT.zh = item.businessName
              itemT.explain = item.businessDescription
              itemT.en = item.businessEnglishName
            }
          }
          for (const itemT of this.bottomBlist) {
            if (item.displayOrder === itemT.displayOrder) {
              itemT.zh = item.businessName
              itemT.explain = item.businessDescription
              itemT.en = item.businessEnglishName
            }
          }
        }
        // 服务案例数据处理
        this.serviceBgList = chunkArray(Alldata.serviceCasesList, 3)
        this.serviceLgList = chunkArray(Alldata.serviceCasesList, 4)
        // 处理公司数据
        let companyInfoFont = Alldata.companyInfo
        this.companyInfo = Alldata.companyInfo
        for (const item of this.contactUsList) {
          if (item.id === 1) {
            item.detailedInfo = companyInfoFont.address
          } else if (item.id === 2) {
            item.detailedInfo = companyInfoFont.inquiryPhone
          } else if (item.id === 3) {
            item.detailedInfo = companyInfoFont.businessPhone
          } else if (item.id === 4) {
            item.detailedInfo = companyInfoFont.contactEmail
          }
        }
        this.companyImgUrl = companyInfoFont.pcMapImageUrl
        this.companyImgUrlmobil = companyInfoFont.mobileMapImageUrl
        // 处理友情链接数据
        let friendlyLinks = Alldata.websiteConfig ? JSON.parse(Alldata.websiteConfig.friendlyLinks) : {};
        this.friendlyLinks = friendlyLinks
        // 处理二维码数据
        this.websiteConfig.weChat = Alldata.websiteConfig.officialAccountQrcodeUrl
        // 存储网页配置数据
        localStorage.setItem("websiteConfig", JSON.stringify(Alldata.websiteConfig))

      },

      handleNewData(data) {
        for (const item of data) {
          item['handleDate'] = dayjs(item.publishDate).format('YYYY/MM/DD') // '25/01/2019'

        }
        this.newsListFirst = data.shift()
        this.newsList = data
      },
      // 跳转详情
      linkInfo(item) {
        // 存取按进去的新闻信息id
        localStorage.setItem("currenObjId", JSON.stringify(item.id))
        this.isNoNewsPage = false
        this.currentIndex = 5
        localStorage.setItem("isNoNewsPage", this.isNoNewsPage)
        localStorage.setItem("currentIndex", this.currentIndex)
        this.$router.push({
          name: "NewsInfo",
          params: { id: item.id },
        }).catch(error => {
          if (error.name === 'NavigationDuplicated') {
            console.warn('尝试导航到当前页面，已忽略重复操作');
          } else {
            throw error;
          }
        });
      },

    },
    watch: {
      '$route'(to, from) {
      }
    },
    beforeUnmount() {
      console.log('11111')
    }
  }
</script>

<style scoped>
  @import "./../../assets/web/css/header.css";
  @import "./../../assets/web/css/layout.css";
  @import "./../../assets/web/css/header.css";
  @import "./../../assets/web/css/newsContent.css";
  @import "./../../assets/web/css/newsInfo.css";
  @import "./../../assets/web/css/newsList.css";
  /* @import "./../assets/web/css/content.css"; */
  /* @import "./../assets/web/css/footer.css"; */
  /* @import "./../assets/widget/css/widget.css"; */
  /* @import "./../assets/icon/css/icon.css"; */
  /* @import "./../assets/table/css/table.css"; */
</style>